module.exports = __webpack_public_path__ + "img/showcase-searches-fr-ca.9c8c9922.jpg";